import React from 'react'
import { observer } from 'mobx-react'
import { Form } from 'components/Form'
import WorkingIndicator from '../WorkingIndicator'
import QuestionChallengeView from './QuestionChallenge/View'
import ChoicesChallengeView from './ChoicesChallenge/View'
import ImageChoicesChallengeView from './ImageChoicesChallenge/View'
import ImageChallengeView from './ImageChallenge/View'
import PrerealtimeChallengeView from './PrerealtimeChallenge/View'
import RealtimeChallengeView from './RealtimeChallenge/View'
import './styles.sass'

const CHALLENGE_VIEWS = {
  question: QuestionChallengeView,
  choices: ChoicesChallengeView,
  image: ImageChallengeView,
  image_choices: ImageChoicesChallengeView,
  prerealtime: PrerealtimeChallengeView,
  realtime: RealtimeChallengeView
}

const MultiFactorAuth = ({ state }) => (
  state.submitting
    ? <WorkingIndicator>Submitting answer..</WorkingIndicator>
    : (
      <div className="multi-factor-auth">
        <div className="question has-text-centered">
          {state.challenge.question}
        </div>
        <Form onSubmit={() => state.submitAnswer()}>
          <ChallengeView challenge={state.challenge} />
          <div className="actions">
            <button className="button is-action">
              Answer
            </button>
          </div>
        </Form>
      </div>
    )
)

export default observer(MultiFactorAuth)

let ChallengeView = ({ challenge }) => {
  const View = CHALLENGE_VIEWS[challenge.type]
  return <View challenge={challenge} />
}

ChallengeView = observer(ChallengeView)



// WEBPACK FOOTER //
// ./src/client/components/LinkAccountDialog/QuovoProvider/MultiFactorAuth/index.jsx